import { useEffect, useState, useCallback } from "react";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, brl, fmtDate, fmtQty, todayISO } from "@/lib/api";

function Losses() {
  const [r, setR] = useState({ start: todayISO(30), end: todayISO() });
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/stock/reports/losses", { params: r }).then((x) => setData(x.data)), [r]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="card-surface" data-testid="losses-report">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b p-4">
        <p className="eyebrow">Relatório de perdas</p>
        <div className="flex gap-2"><Input type="date" value={r.start} onChange={(e) => setR((x) => ({ ...x, start: e.target.value }))} className="w-auto h-9" /><Input type="date" value={r.end} onChange={(e) => setR((x) => ({ ...x, end: e.target.value }))} className="w-auto h-9" /></div>
      </div>
      <Table>
        <TableHeader><TableRow><TableHead>Item</TableHead><TableHead className="text-right">Quantidade perdida</TableHead><TableHead className="text-right">Valor</TableHead></TableRow></TableHeader>
        <TableBody>
          {data?.items.map((i) => <TableRow key={i.name}><TableCell>{i.name}</TableCell><TableCell className="text-right font-mono">{fmtQty(i.qty)} {i.unit}</TableCell><TableCell className="text-right font-mono text-red-500">{brl(i.value)}</TableCell></TableRow>)}
          {data && !data.items.length && <TableRow><TableCell colSpan={3} className="py-6 text-center text-muted-foreground">Nenhuma perda no período.</TableCell></TableRow>}
        </TableBody>
      </Table>
      <p className="border-t p-4 text-right text-sm">Total perdido: <b className="font-mono text-red-500" data-testid="losses-total">{brl(data?.total_value)}</b></p>
    </div>
  );
}

function Idle() {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/stock/reports/idle", { params: { days } }).then((x) => setData(x.data)); }, [days]);
  return (
    <div className="card-surface" data-testid="idle-report">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b p-4">
        <p className="eyebrow">Produtos parados</p>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} className="h-9 rounded-md border bg-transparent px-2 text-sm" data-testid="idle-days-select">
          {[7, 15, 30, 60, 90].map((d) => <option key={d} value={d}>Sem venda há {d} dias</option>)}
        </select>
      </div>
      <Table>
        <TableHeader><TableRow><TableHead>Produto</TableHead><TableHead className="text-right">Estoque</TableHead><TableHead>Última venda</TableHead><TableHead className="text-right">Valor parado</TableHead></TableRow></TableHeader>
        <TableBody>
          {data?.items.map((i) => <TableRow key={i.id}><TableCell>{i.name}</TableCell><TableCell className="text-right font-mono">{i.stock == null ? "—" : `${fmtQty(i.stock)} ${i.unit}`}</TableCell><TableCell>{i.last_sale_at ? fmtDate(i.last_sale_at) : "Nunca vendido"}</TableCell><TableCell className="text-right font-mono">{brl(i.value)}</TableCell></TableRow>)}
          {data && !data.items.length && <TableRow><TableCell colSpan={4} className="py-6 text-center text-muted-foreground">Todos os produtos tiveram venda no período.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </div>
  );
}

export function StockReports() {
  return <div className="grid gap-6 xl:grid-cols-2"><Losses /><Idle /></div>;
}
